import React from "react";

const MatchDetailsFormatCard = ({ svg, title, desc }) => {
  return (
    <div>
      <div className="flex flex-col justify-center items-center border border-gray-700 bg-black bg-opacity-60 rounded-xl py-1 px-1 w-full text-center sm:text-left">
        <img
          src={svg}
          className="flex-shrink-0   w-full h-16  "
          style={{ color: "white" }}
        />

        <div className="flex flex-col  text-center py-2 pr-2">
          <h4 className="text-lg font-light">{title}</h4>
          <p className="text-sm font-hairline">{desc}</p>
        </div>
      </div>
    </div>
  );
};

export default MatchDetailsFormatCard;
